var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// var Popper = require('popper.js');
// window.Popper = Popper;
require('moment');
require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

// require('jquery.placeholder');
// require('jquery-sticky');
// require('jquery-match-height');

require('owl.carousel');
// const WOW = require('wow.js');
require('magnific-popup');
require('lazysizes');
require('picturefill');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded




$(function() {

    if ($('.gallery-container').length) {
        $('.gallery-container').each(function() { // the containers for all your galleries
            $(this).magnificPopup({
                delegate: 'a', // the selector for gallery item
                type: 'image',

                gallery: {
                  enabled:true
                },
                disableOn: function() {
                    if ($(window).width() < 600) {
                        return false;
                    }
                    return true;
                }
            });
        });
    }

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').on('click', function() {
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).toggleClass('btn-close')
        $('.main-nav--navbar-brand').toggleClass('active-mob');

    });

    //Click event to scroll to top``
    $("#page-up").click(function() {
        $('html, body').animate({
          scrollTop: 0
        }, 800);
        return false;

    }); 

    $(window).scroll(function() {
        if ($(".main-nav").offset().top > 50) {
            $(".main-nav").addClass("navbar--shrink");

        } else {
            $(".main-nav").removeClass("navbar--shrink");
        }
    });


    

    if ($('.main-slider').length) {
        $('.main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 7000,
            smartSpeed: 1000,
            navText : ["<i class='material-icons'>play_arrow</i>","<i class='material-icons'>play_arrow</i>"],
            responsive:{
                
                
                 994:{
                    nav: true,
                    dots: false,
                }
                
            }
           
        })
    }

    if ($('.services-slider').length) {
        $('.services-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            smartSpeed: 1000,
            responsive:{
                
                576:{
                    items:2,
                },
                 768:{
                    items:3,
                },
                 994:{
                    items:4,
                },
                 1200:{
                    items:5,
                    autoplay: false,
                }
                
            }
        })
    }

    if ($('.our-services-slider').length) {
        $('.our-services-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            smartSpeed: 1000,
            responsive:{
                
                576:{
                    items:2,
                },
                 768:{
                    items:2,
                },
                 1200:{
                    items:3,
                    autoplay: false,
                }
                
            }
        })
    }
})


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js